import {
  Serializable,
  serializeObject
} from "../serialization";
class ControlDefinition extends Serializable {
  constructor(config) {
    super();
    this.config = config;
  }
  mergeData(base, override = base, _context) {
    return override;
  }
  getTranslatableData(_data) {
    return null;
  }
  mergeTranslatedData(data, _translatedData, _context) {
    return data;
  }
  introspect(data, target) {
    return target.introspect(data);
  }
}
function serialize(config, rest) {
  const [serializedConfig, transferables] = serializeObject(config);
  return [
    {
      config: serializedConfig,
      ...rest
    },
    transferables
  ];
}
export {
  ControlDefinition,
  serialize
};
//# sourceMappingURL=definition.js.map